import React, { useMemo } from "react";
import InputMascara from "./InputMascara";
import useFormItemStatus from "antd/es/form/hooks/useFormItemStatus";

export default function InputCpfCnpj(props) {
	const { value, onChange, ...rest } = props;

	const formStatus = useFormItemStatus();

	const classes = useMemo(() => {
		const classes = [];
		if (formStatus.status === "error") {
			classes.push("ant-input-status-error");
		}
		return classes;
	}, [formStatus]);

	return (
		<InputMascara
			mask={{
				11: "999.999.999-999",
				15: "99.999.999/9999-99",
			}}
			value={value}
			onChange={onChange}
			classes={classes}
			{...rest}
		/>
	);
}
